import React, { useEffect, useRef } from "react";

export const Services = (props) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add("is-visible");
          observer.unobserve(section);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div id="serv" ref={sectionRef}>
      <div className="container">
        <div className="row d-flex">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <span className="about-eyebrow">Plataforma XisPay</span>
              <h2>Soluções que aceleram operações digitais de alta demanda</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 d-flex">
            <div className="serv-visual">
              <span className="serv-visual-halo" aria-hidden="true" />
              <img
                src="/img/image-Photoroom%20(1)%20(1).png"
                className="img-responsive serv-logo"
                alt="Logo XisPay"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
